import React, {useState, useEffect} from 'react';
import './EditTraceModal.css';

interface SaveTraceModalProps {
    isOpen: boolean;
    isSaving: boolean;
    error: string | null;
    onConfirm: (name: string, description: string) => void;
    onCancel: () => void;
}

const SaveTraceModal: React.FC<SaveTraceModalProps> = ({isOpen, isSaving, error, onConfirm, onCancel}) => {
    const [name, setName] = useState('Nouveau parcours');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (isOpen) {
            setName('Nouveau parcours');
            setDescription('');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmedName = name.trim();
        if (!trimmedName) return;
        onConfirm(trimmedName, description.trim());
    };

    return (
        <div className="edit-trace-overlay" onClick={onCancel}>
            <div className="edit-trace-modal" onClick={e => e.stopPropagation()}>
                <div className="edit-trace-header">
                    <h3>Sauvegarder la trace</h3>
                    <button className="edit-trace-close" onClick={onCancel} disabled={isSaving} aria-label="Fermer">✕</button>
                </div>
                <form className="edit-trace-form" onSubmit={handleSubmit}>
                    <div className="edit-trace-field">
                        <label htmlFor="save-trace-name">Nom</label>
                        <input
                            id="save-trace-name"
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            maxLength={200}
                            autoFocus
                            required
                        />
                    </div>
                    <div className="edit-trace-field">
                        <label htmlFor="save-trace-desc">Description <span style={{fontWeight: 400, color: '#888'}}>(optionnelle)</span></label>
                        <textarea
                            id="save-trace-desc"
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                            rows={3}
                            maxLength={1000}
                        />
                    </div>
                    {error && <div className="edit-trace-error">{error}</div>}
                    <div className="edit-trace-actions">
                        <button type="button" className="edit-trace-btn secondary" onClick={onCancel} disabled={isSaving}>
                            Annuler
                        </button>
                        <button type="submit" className="edit-trace-btn primary" disabled={isSaving || !name.trim()}>
                            {isSaving ? 'Enregistrement…' : 'Enregistrer'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SaveTraceModal;
